import { transport } from 'config/transport';

export function callApiUpdateTuition(congDoanId, classId, invoiceId, tuitionId, body) {
    return transport.put(`/mamnon/${congDoanId}/thuhocsinh/${classId}/phieuthu/${invoiceId}/tuitions/${tuitionId}`, body);
}
